module.exports = __webpack_public_path__ + "static/img/bk_galaxy.ee3f6224.jpg";